import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "../../css/Dashboard.module.css";
import Chatbot from "../SharedComponents/Chatbot";

const RecruiterDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/recruiter/login");
        return;
      }
  
      const response = await axios.get("https://techservicemarket-backend.onrender.com/api/recruiter/jobs", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setJobs(response.data);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  const handleDeleteJob = async (jobId) => {
    const confirmed = window.confirm("Are you sure you want to delete this job?");
    if (!confirmed) return;
  
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/recruiter/login");
        return;
      }
  
      await axios.delete(`https://techservicemarket-backend.onrender.com/api/recruiter/jobs/${jobId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      alert("Job deleted successfully");
      fetchJobs();
    } catch (error) {
      console.error("Error deleting job:", error);
    }
  };

  return (
    <div className={styles.dashboardContainer}>
      <h1 className={styles.dashboardHeader}>Recruiter Dashboard</h1>

      {/* Post Job Button */}
      <button
        onClick={() => navigate("/recruiter/jobs/new")}
        className={styles.searchButton}
        style={{ alignSelf: "center", marginBottom: "20px" }}
      >
        Post a New Job
      </button>

      {/* Job List Section */}
      <div className={styles.jobListSection}>
        <h2>Your Posted Jobs</h2>
        {jobs.map((job) => (
          <Link to={`/recruiter/jobs/${job._id}/edit`} key={job._id} className={styles.jobCardLink}>
            <div className={styles.jobCard}>
              <h3>{job.title}</h3>
              <p><strong>Company:</strong> {job.company}</p>
              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Job Type:</strong> {job.jobType}</p>
              <p><strong>Salary:</strong> {job.salary || "Not specified"}</p> {/* Display salary */}
              <p><strong>Description:</strong> {job.description}</p> {/* Display description */}
              <p><strong>Requirements:</strong> {job.requirements.join(", ")}</p>

              <div className={styles.jobActions} style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button
                  onClick={(e) => {
                    e.preventDefault(); // Prevents link navigation
                    handleDeleteJob(job._id);
                  }}
                  className={styles.searchButton}
                  style={{ backgroundColor: "#dc3545" }}
                >
                  Delete
                </button>
                <Link to={`/recruiter/jobs/${job._id}/applications`} className={styles.searchButton} style={{ backgroundColor: "#17a2b8", textDecoration: "none", color: "#fff", padding: "10px 20px", borderRadius: "5px", textAlign: "center" }}>
                  View Applications
                </Link>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <Chatbot />
    </div>
  );
};

export default RecruiterDashboard;
